import { CustomerApplicationTagEntityQueryOptions, CustomerApplicationTemplateEntityQueryOptions, fetchCustomerApplicationTemplates, fetchCustomerApplicationTemplateTags } from "Hooks/Api/apiCustomerApplications";
import useAsync from "Hooks/useAsync";

export function useCustomerApplicationTemplates(filters?: CustomerApplicationTemplateEntityQueryOptions) {
	const applicationForms = useAsync(async () => {
		const response = await fetchCustomerApplicationTemplates(filters);
		return response.data;
	}, [filters]);

	return applicationForms;
}

export function useCustomerApplicationTemplateTags(filters?: CustomerApplicationTagEntityQueryOptions) {
	const useResponse = useAsync(async () => {
		const response = await fetchCustomerApplicationTemplateTags(filters);
		return response.data;
	}, [filters]);

	return useResponse;
}

